import { packages } from './packages';
import { sellerDashboard } from './sellerDashboard';
import { sitewide } from './sitewide';

export const tracking = {
  packages,
  sellerDashboard,
  sitewide,
};
